import { format, parseISO } from "date-fns";

class User {

    constructor(d) {
        return Object.assign(this, d);
    }

    getFullName() {
        return this.email;
    }

    getCreatedAt() {
        return format(parseISO(this.createdAt), "yyyy. MM. dd. HH:mm:ss");
    }

}

export default User;